import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import AdminModal from '../../reusable/admin-modal/admin-modal.component';
import Button from '../../reusable/button/button.component';
import Spinner from '../../reusable/spinner/spinner.component';

import { ToastContext } from '../../../contexts/toast.context';

import Client from '../../../tools/client';
import { api } from '../../../config.js';

import {
  ButtonContainer,
  ButtonRowContainer,
  DeleteButton,
  InputContainer,
  MainContainer,
  ProductContent,
  UpdateInput,
  UpdateLabel,
  UpdateTextarea,
  UpdateSelect,
  UpdateOption,
} from './update-category.styles';

const client = new Client();

const UpdateCategory = ({ category, setShowEdit, getCategory }) => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [categoryTypes, setCategoryTypes] = useState([]);
  const [name, setName] = useState(category.name);
  const [description, setDescription] = useState(category.description);
  const [categoryTypeId, setCategoryTypeId] = useState({ value: category.categoryTypeId, label: '' });
  const [status, setStatus] = useState(category.status);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const { errorToast, successToast } = useContext(ToastContext);

  useEffect(() => {
    getCategoryTypes();
  }, []);

  const getCategoryTypes = async () => {
    setLoading(true);
    const res = await client.getAllCategoryTypes();

    const options = res.map((ct) => ({ value: ct.id, label: ct.name }));
    setCategoryTypes(options);

    const selected = options.find((opt) => opt.value === category.categoryTypeId);
    if (selected) setCategoryTypeId(selected);

    setLoading(false);
  };

  const confirmDelete = () => {
    setShowDeleteModal(true);
  };

  const deleteCategory = async () => {
    const res = await client.deleteCategory({ id: category.id });

    if (res.status === 403) {
      setShowDeleteModal(false);
      errorToast(res.message);
      return;
    }

    navigate('/categories');
  };

  const updateCategory = async () => {
    setLoading(true);

    if (!name || !description || !categoryTypeId?.value) {
      errorToast('Please fill out all fields to update category.');
      setLoading(false);
      return;
    }

    const data = {
      id: category.id,
      name,
      description,
      categoryTypeId: categoryTypeId.value,
      status,
    };

    const res = await client.updateCategory(data);

    if (res.status === 400) {
      setLoading(false);
      errorToast(res.message);
      return;
    }

    successToast('Category Updated');
    await getCategory();
    setLoading(false);
    setShowEdit(false);
  };

  return (
    <MainContainer>
      <AdminModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        title={'Delete Category'}
        image={category.thumbnailPath ? api + category.thumbnailPath : ''}
        message={`Are you sure you want to delete ${category.name} and all associated images forever?`}
        action={deleteCategory}
        actionText={'Delete'}
      />

      {loading ? (
        <Spinner />
      ) : (
        <>
          <ProductContent>
            <InputContainer>
              <UpdateLabel>Name:</UpdateLabel>
              <UpdateInput value={name} onChange={(e) => setName(e.target.value)} />
            </InputContainer>
            <InputContainer>
              <UpdateLabel>Description:</UpdateLabel>
              <UpdateTextarea value={description} onChange={(e) => setDescription(e.target.value)} />
            </InputContainer>
            <InputContainer>
              <UpdateLabel>Type:</UpdateLabel>
              <Select
                options={categoryTypes}
                value={categoryTypeId}
                onChange={setCategoryTypeId}
                placeholder="Select category type..."
              />
            </InputContainer>
            <InputContainer>
              <UpdateLabel>Status:</UpdateLabel>
              <UpdateSelect value={status} onChange={(e) => setStatus(e.target.value === 'true')}>
                <UpdateOption value={true}>Active</UpdateOption>
                <UpdateOption value={false}>Inactive</UpdateOption>
              </UpdateSelect>
            </InputContainer>
          </ProductContent>
          <ButtonContainer>
            <DeleteButton onClick={() => confirmDelete()}>DELETE</DeleteButton>
            <ButtonRowContainer>
              <Button onClick={() => setShowEdit(false)}>Cancel</Button>
              <Button onClick={() => updateCategory()}>Update</Button>
            </ButtonRowContainer>
          </ButtonContainer>
        </>
      )}
    </MainContainer>
  );
};

export default UpdateCategory;